export const API_KEY = 'AIzaSyBcRyXohIi6_V85-SKlPTIMwk1DovpEv2Y'
